export abstract class FormattedNumber {
  private _amount: number

  // eslint-disable-next-line
  public static fromString<T extends FormattedNumber> (this: new (value: number) => T, stringifiedAmount: string): T {
    const parsedValue = stringifiedAmount.replace(/\./g, '').replace(',', '.')
    return new this(parseFloat(parsedValue))
  }

  constructor (amount: number) {
    if (amount < 0) {
      throw new TypeError('FormattedNumber amount must not be below zero')
    }
    this._amount = amount
  }

  value (): number {
    return this._amount
  }

  toString (): string {
    const stringifiedAmount = this._amount.toFixed(2).replace('.', ',')
    return stringifiedAmount
  }

  pointToString (): string {
    const stringifiedAmount = this._amount.toFixed(2).replace('.', ',')

    const splitNum = stringifiedAmount.split(',')
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return splitNum.join(',')
  }
}
